const handleDigits = function (e) {
    const isEnterKey = e.which === 13;
    if (isEnterKey) {
        $('button#verification_code__submit').click();
        return false;
    }

    const onlyDigits = $(this).val().replace(/\D/g,'');
    $(this).val(onlyDigits);

    if (onlyDigits === '') {
        return false;
    }

    const $verificationCode = $('#verification_code__all');
    const digitKey = parseInt($(this).attr('id').replace('verification_code__digit', ''));
    const digit = $(this).val().toString();
    if (digit.length === 1) {
        // build the verification code string and set it into the input's val
        const $digits = $('#component__one_time_code__verification input[id^="verification_code__digit"]');
        let verificationCode = '';
        $digits.each((i, el) => verificationCode += $(el).val());
        $verificationCode.val(verificationCode).change();

        // set the focus on the next input
        $('#verification_code__digit' + (digitKey + 1)).focus();
    } else if (digit.length > 1) {
        const allDigits = digit.split('');
        let digitToFill = digitKey;
        allDigits.forEach((d) => {
            const $currDigit = $('#verification_code__digit' + digitToFill);
            if ($currDigit) {
                $currDigit.val(d).focus();
                digitToFill += 1;
            }
        });
        $verificationCode.val(digit).change();
    }
};

const OneTimeCodeVerification = {
    init: () => {
        $(document).on('input', '#component__one_time_code__verification input[id^="verification_code__digit"]', handleDigits);
        $(document).on('click', 'button#verification_code__submit', function (e) {
            e.preventDefault();

            $('button#verification_code__submit').prop('disabled', true);

            const event = new CustomEvent(
                'one-time-code:verification:submit',
                {
                    bubbles: true,
                    detail: {
                        verificationMethod: $('#component__one_time_code__verification_method').val(),
                        verificationCode: $('#verification_code__all').val(),
                    },
                },
            );

            document.querySelector('button#verification_code__submit').dispatchEvent(event);
        });
        $(document).on('change', '#verification_code__all', function () {
            if ($(this).val().toString().length === 6) {
                $('button#verification_code__submit').click();
            }
        });
        $(document).ready(function () {
            const $digits = $('#component__one_time_code__verification input[id^="verification_code__digit"]');
            $digits.each((i, el) => {
                const $input = $(el);
                if ($input.val() !== '') {
                    $(el).val('').change();
                }
            });
        });
    },
};

export default OneTimeCodeVerification;
